import { IonIcon } from "@ionic/react";
import { play } from "ionicons/icons";
import React from "react";
import { useContext } from "react";

import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { CardProps } from "../interfaces/core";
import useIntersection from "../lib/useIntersection";
import ThumbVideoContext from "../lib/ThumbVideoContext";

const ThumbnailVideo: React.FC<
  CardProps["video"] & { src: string; onVideoPlay: (e: any) => void }
> = ({ mp4, webm, filename, src, onVideoPlay }) => {
  const { videos, setVideos } = useContext(ThumbVideoContext);
  const [paused, setPaused] = useState(true);
  const videoRef = useRef<HTMLVideoElement>(null);
  const inView = useIntersection(videoRef, "-150px");
  const playVideo = async (video: HTMLVideoElement | null) => {
    if (video) {
      videos.forEach((v) => {
        v.pause();
      });
      video.currentTime = 0.05;
      await video.play();
    }
  };
  useEffect(() => {
    const el = videoRef.current;
    if (el) {
      const prevVideos = videos;
      if (inView) {
        prevVideos.push(el);
        setVideos(prevVideos);
      } else if (!inView) {
        el.pause();
        setVideos(prevVideos.filter((v) => v !== el));
      }
    }
    return () => {};
  }, [inView]);

  return (
    <div className="video-player relative">
      <div
        className={`w-full h-full absolute z-[3] flex justify-center items-center transition-opacity ${
          paused ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}
      >
        <button
          onClick={async (e) => {
            onVideoPlay(e);
            playVideo(videoRef.current);
          }}
          className="rounded-full overflow-hidden transitionƒ bg-white/20 hover:bg-white/5 active:scale-95 backdrop-filter backdrop-blur-2xl flex"
        >
          <IonIcon
            icon={play}
            className="w-6 h-6 p-4 translate-x-[1px] text-white"
          />
        </button>
      </div>
      <img
        src={src}
        alt="cover"
        className={`z-[2] absolute inset-0 w-full h-full transition ${
          paused ? "opacity-100" : "opacity-0"
        }`}
      />
      <video
        ref={videoRef}
        muted
        playsInline
        controls={false}
        className="video"
        style={{ width: "100%", aspectRatio: "4 / 3" }}
        poster={src}
        onPlay={() => setPaused(false)}
        onPause={() => setPaused(true)}
        onEnded={() => setPaused(true)}
      >
        {mp4 && (
          <source src={`/assets/videos/${filename}.mp4`} type="video/mp4" />
        )}
        {webm && (
          <source src={`/assets/videos/${filename}.webm`} type="video/webm" />
        )}
      </video>
    </div>
  );
};
export default ThumbnailVideo;
